'use client';
import PropTypes from 'prop-types';
import React__default from 'react';
import { renderWithRef } from '../core/render-with-ref.js';
import { RenderComp } from '../core/render-comp.component.js';

const propTypes = {
    /**
   * Whether to hide the first banner on screens smaller than Medium
   */ hideFirstBannerBelowMedium: PropTypes.bool,
    /**
   * Whether to hide the second banner on screens smaller than Medium
   */ hideSecondBannerBelowMedium: PropTypes.bool
};
const propKeysToRemove = Object.keys(propTypes);
/**
 * @subcomponent Banner
 */ const DoubleBanner = renderWithRef('DoubleBanner', propTypes, (props, ref)=>{
    const { children, hideFirstBannerBelowMedium, hideSecondBannerBelowMedium } = props;
    const classNameSet = new Set([
        'swan-double-banner'
    ]);
    if (hideFirstBannerBelowMedium) classNameSet.add('swan-double-banner-hide-first-banner-below-medium');
    if (hideSecondBannerBelowMedium) classNameSet.add('swan-double-banner-hide-second-banner-below-medium');
    return /*#__PURE__*/ React__default.createElement(RenderComp, {
        root: "div",
        forwardedRef: ref,
        propKeysToRemove: propKeysToRemove,
        classNames: classNameSet,
        props: props
    }, children);
});

export { DoubleBanner };
